var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 将 post/put 方法中的 data: {foo: 'a', bar: 'b'}
 * 转换成 foo=a&bar=b 的 string 形式
 *
 * 依赖 URLSearchParams / URL
 * 低版本兼容可以考虑使用 polyfill: https://www.npmjs.com/package/url-polyfill
 * 或
 * 使用 core-js 中的相关 package 作为替换
 */
export var dataStringInterceptor = function (conf) {
    var method = conf.method, data = conf.data;
    if (method && method.toUpperCase() !== 'POST' &&
        method.toUpperCase() !== 'PUT') {
        return conf;
    }
    var _conf = __assign({}, conf);
    _conf.data = obj2str(data || {});
    return _conf;
};
// helper
// 因为搜狗浏览器 @8.5版本对 URLSearchParams 的支持不好
// 所以这里改用传统的 obj2string 方式了
function obj2str(data, encode, empty) {
    if (encode === void 0) { encode = false; }
    if (empty === void 0) { empty = false; }
    var _data = Object.assign({}, data);
    if (empty) {
        Object.keys(_data).map(function (key) {
            if (_data[key] === undefined || _data[key] === null) {
                delete _data[key];
            }
        });
    }
    var params = Object.keys(_data).map(function (key) {
        if (encode) {
            return "".concat(key, "=").concat(encodeURIComponent(_data[key]));
        }
        return "".concat(key, "=").concat(_data[key]);
    }).join('&');
    return params;
}
//# sourceMappingURL=data-string.js.map